import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { router_config } from '../../configs/route.config'
import Layout from '../../layout/userLayout'
import { useAppStore } from '../../store/appStore'
import { useAuthStore } from '../../store/authStore'

type Props = {
  children: React.ReactNode
  slug_key: string
  hasChild?: boolean
}

const UserRoute = ({ children, slug_key, hasChild = false }: Props) => {
  const { roleData } = useAuthStore()
  const { setActiveRouteSlug, setMenuOpened } = useAppStore()
  const location = useLocation()

  useEffect(() => {
    if (!hasChild) {
      setActiveRouteSlug(slug_key)
    }
    setMenuOpened(false)
    // Scroll to top when route changes
    window.scrollTo(0, 0)
    // eslint-disable-next-line
  }, [slug_key, location?.pathname])

  console.log('UserRoute', slug_key, roleData)
  // if (!authenticated) return <Navigate to="/" replace />
  const hasPermission = () => {
    // if (!authenticated) return false // Admin has full permissions

    const currentRouteConfig = router_config[slug_key]
    if (currentRouteConfig.permission_slugs.length === 0) {
      return true
    } else if (
      roleData &&
      roleData.name &&
      currentRouteConfig &&
      currentRouteConfig.permission_slugs.length > 0
    ) {
      const trimmedRoleName = roleData.name.trim() // Trim whitespace
      return currentRouteConfig.permission_slugs.includes(trimmedRoleName)
    }

    return true // No specific permissions required or roleData not available
  }

  return (
    <Layout>{hasPermission() ? <>{children}</> : <> No Permission </>}</Layout>
  )
}

export default UserRoute
